
export const REGISTER_PAGE_TESTIMONIALS = [
  {
    key: 'item_1',
    src: 'https://www.g2.com/products/clearout-io/reviews/clearout-io-review-8378119#survey-response-8378119',
    caption: "Stopping irrelevant people from submitting Demo Requests and Contacting Us on forms. It enables us to ensure that they use a business email rather than a free personal email address, meaning we're not sifting through bad leads.",
    name: "Iain M.",
    designation: "Head of Demand Generation"
  },
  {
    key: 'item_2',
    src: 'https://www.g2.com/products/clearout-io/reviews/clearout-io-review-8377059',
    caption: "Clearout is one of my top five go-to options for finding prospects. The process of verifying emails has proven to be helpful in identifying B2B contacts and generating several lists of potential prospects.",
    name: "Seth D.",
    designation: "Business Owner"
  },
  {
    key: 'item_3',
    src: 'https://www.g2.com/products/clearout-io/reviews/clearout-io-review-7781153',
    caption: "Having clean data and validating our prospect emails are a critical part of our business. This service not only delivers the data we need it provides an inside view to go to market waste with data providers.",
    name: "Edward Y.",
    designation: "Vice President Sales Operations"
  }
]